import { useContext } from 'react';

import { VehiclesContext } from '../contexts';
import { VehicleContextProps } from '../contexts/types';

export function useVehicles(): VehicleContextProps {
    return useContext(VehiclesContext);
}
